import { gql } from 'apollo-angular';

const GET_DIFF_LOG = gql`
  query organizationDiffLog($organizationId: Long) {
    organizationDiffLog(organizationId: $organizationId) {
      aptitudeOrg {
        id
        name
        memberId
        gln
        organizationType
        address {
          id
          addressType
          address1
          address2
          city
          state
          zip
        }
        aptitudeAgreement {
          id
          status
          effectiveDate
          terminationDate
        }
        analyticsAgreement {
          id
          status
          effectiveDate
          terminationDate
        }
        parents {
          id
          name
        }
      }
      vizientOrg {
        id
        name
        memberId
        gln
        organizationType
        address {
          id
          addressType
          address1
          address2
          city
          state
          zip
        }
        aptitudeAgreement {
          id
          status
          effectiveDate
          terminationDate
        }
        analyticsAgreement {
          id
          status
          effectiveDate
          terminationDate
        }
        parents {
          id
          name
        }
      }
      messages
      vizientParentExists
      vizientOrgExists
    }
  }
`;

export default GET_DIFF_LOG;
